module.exports = __webpack_public_path__ + "static/media/xibao.084416cd.png";